import { useState, type ReactNode } from 'react';

interface GroupImageProps {
  src?: string | null;
  imageClassName: string;
  fallbackClassName: string;
  fallback: ReactNode;
}

/**
 * Decorative group image that replaces missing and failed URLs with the
 * surface's group placeholder instead of leaving a broken-image glyph.
 */
export function GroupImage({
  src,
  imageClassName,
  fallbackClassName,
  fallback,
}: GroupImageProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const showImage = Boolean(src && failedSrc !== src);

  if (showImage) {
    return (
      <img
        className={imageClassName}
        src={src ?? undefined}
        alt=""
        aria-hidden
        onError={() => setFailedSrc(src ?? null)}
      />
    );
  }

  return (
    <span className={fallbackClassName} aria-hidden>
      {fallback}
    </span>
  );
}
